import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../enviroments/enviroment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiResponseLogin } from '../../models/AuthModel';
import { Observable } from 'rxjs';
import { UserDataResponse } from '../../models/UserDataModel';
import { AESUtil } from '../../../shared/adapters/crypto-adapter';
import { KeyStorageUtil } from '../../../shared/utils/keystorage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  loginUrlEndpoint: string = `${environment.urlEndPoint}/api/login`;
  userDataUrlEndpoint: string = `${environment.urlEndPoint}/api/usuario?username=`;
  logoutUrlEndpoint: string = `${environment.urlEndPoint}/api/logout`;

  constructor(private http: HttpClient, private router: Router) {}
  login(username: string, password: string): Observable<ApiResponseLogin> {
    const key = AESUtil.generateKey();
    const iv = AESUtil.generateIv();

    const cypherText = AESUtil.encrypted(password, key, iv);

    //TODO: testear el error 401
    if (username === '401') {
      return new Observable((observer) => {
        observer.error({ status: 401, error: { message: 'Unauthorized' } });
      });
    }
    return this.http.post<ApiResponseLogin>(
      this.loginUrlEndpoint,
      {
        username,
        token: cypherText,
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'X-Enc-Key': key,
          'X-Enc-IV': iv,
        }),
      }
    );
  }

  fetchUserData(username: string): Observable<UserDataResponse> {
    return this.http.get<UserDataResponse>(
      `${this.userDataUrlEndpoint}${username}`
    );
  }

  isAuthenticated(): boolean {
    return !!KeyStorageUtil.getItem<string>('token');
  }

  getDateExpirationToken() {
    const tokenExpiracion = KeyStorageUtil.getItem('exp');
    const fechaExpiracion = new Date(0);
    fechaExpiracion.setUTCSeconds(+tokenExpiracion!);
    const hoy = new Date();

    if (fechaExpiracion < hoy) {
      KeyStorageUtil.clear();
      return false;
    } else {
      return true;
    }
  }

  logout(): void {
    if (!this.getBlackList()) {
      console.log(
        `El Flujo de cierre de sesión no se realizo en forma correcta, favor validar.`
      );
    }
    KeyStorageUtil.clear();

    this.router.navigate(['/login']);
  }

  getBlackList(): boolean {
    const cat = this.http.get<boolean>(this.logoutUrlEndpoint).subscribe();
    return !!cat;
  }
}
